import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { DateTime, NumeroDecimal, SectionTitle } from '../../../../../components'
import { formatarChaveCte } from '../EmissaoCteSubcontratacao/cteSubcontratacao.util'

const estiloDica = { color: 'gray', fontSize: 12 }

export default function SecaoDocumentosCarga({ documentos, carregando = false }) {
  const lista = documentos || []
  const valorTotal = lista.reduce((soma, doc) => soma + Number(doc.valor_nf || 0), 0)
  const pesoTotal = lista.reduce((soma, doc) => soma + Number(doc.peso_total || 0), 0)
  const comRolagem = lista.length > 6

  return (
    <div className="p-col-12" style={{ marginTop: 10 }}>
      <SectionTitle title="Documentos da Carga" />
      <span style={estiloDica}>
        Notas Fiscais vinculadas a este CTe; apenas informativo.
        {lista.length ? (
          <>
            {' '}
            {lista.length} nota{lista.length > 1 ? 's' : ''} · valor R${' '}
            <NumeroDecimal>{valorTotal}</NumeroDecimal> · peso{' '}
            <NumeroDecimal decimalScale={3}>{pesoTotal}</NumeroDecimal> kg
          </>
        ) : null}
      </span>
      <DataTable
        value={lista}
        emptyMessage={carregando ? 'Carregando notas...' : 'Nenhuma nota vinculada'}
        scrollable={comRolagem}
        scrollHeight={comRolagem ? '220px' : undefined}
        style={{ marginTop: 5 }}
      >
        <Column field="identifier" header="Nº NF" style={{ width: 110 }} />
        <Column field="invoice_serie" header="Série" style={{ width: 70 }} />
        <Column
          header="Emissão"
          style={{ width: 110 }}
          body={doc => (doc.data_emissao ? <DateTime>{String(doc.data_emissao)}</DateTime> : '-')}
        />
        <Column
          header="Valor"
          style={{ width: 130, textAlign: 'right' }}
          body={doc => (
            <>
              R$ <NumeroDecimal>{doc.valor_nf}</NumeroDecimal>
            </>
          )}
        />
        <Column
          header="Chave de acesso"
          body={doc => <span style={{ fontSize: 12 }}>{formatarChaveCte(doc.chave_nf)}</span>}
        />
      </DataTable>
    </div>
  )
}
